import React, { useEffect, useContext, useState } from "react";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import LoadingButton from "@mui/lab/LoadingButton";
import CircularProgress from "@mui/material/CircularProgress";
import FeedbackTable from "./Table";
import FeedbackView from "./FeedbackView";
import {
  Typography,
  Pagination,
  Stack,
  Paper,
  Button,
  Box,
} from "@mui/material";
import { feedbackContext } from "../../contexts/FeedbackContext";
export default function Feedback() {
  const { loading, handleSearchFeedback, feedbackCount } =
    useContext(feedbackContext);

  const [values, setValues] = useState({
    fromDate: null,
    toDate: null,
    contactNumber: "",
    // planId: "",
    page: 1,
  });

  useEffect(() => {
    handleSearchFeedback({ ...values });
  }, []);

  const handlePageChange = (event, value) => {
    setValues({ ...values, page: value });
    handleSearchFeedback({ ...values, page: value });
  };

  const handleReset = () => {
    setValues({
      fromDate: null,
      toDate: null,
      contactNumber: "",
      // planId: "",
      page: 1,
    });
    handleSearchFeedback({
      fromDate: null,
      toDate: null,
      contactNumber: "",
      // planId: "",
      page: 1,
    });
  };

  const handleChange = (prop) => (event) => {
    if (prop === "fromDate" || prop === "toDate") {
      setValues({ ...values, [prop]: event });
    } else {
      setValues({ ...values, [prop]: event.target.value });
    }
  };

  const handleEnterKeyPress = (event , value) => {
    if (event.key === "Enter") {
      handleSearchFeedback({ ...values, page: value });
    }
  };


  return (
    <div>
      <Paper
        sx={{
          textAlign: "center",
          padding: "5px",
        }}
      >
        <Box
          sx={{ justifyContent: "center", borderRadius: "5px" }}
          className="heading"
        >
          <Typography variant="h5">
            Feedback(
            {feedbackCount ? parseInt(feedbackCount).toLocaleString() : "NA"})
          </Typography>
        </Box>

        <Stack
          className="SearchButton"
          spacing={6}
          direction="row"
          justifyContent={"flex-middle"}
          marginBottom={1}
          marginTop={1}
        >
          <DesktopDatePicker
            sx={{
              width: "20vw",
              textAlign: "center",
              justifyContent: "center",
            }}
            value={values.fromDate}
            onChange={handleChange("fromDate")}
            label="From*"
            format="DD/MM/YYYY"
            maxDate={values.toDate}
            slotProps={{ textField: { size: "small" } }}
            onKeyPress={handleEnterKeyPress}
          />

          <DesktopDatePicker
            sx={{
              width: "20vw",
              textAlign: "center",
              justifyContent: "center",
            }}
            value={values.toDate}
            onChange={handleChange("toDate")}
            label="To*"
            format="DD/MM/YYYY"
            minDate={values.fromDate}
            slotProps={{ textField: { size: "small" } }}
            onKeyPress={handleEnterKeyPress}
          />
          

          <LoadingButton
            loading={loading}
            loadingPosition="center"
            onClick={() => {
              setValues({ ...values, page : 1})
              handleSearchFeedback({ ...values, page: 1 });
            }}
            variant="contained"
            className="search-button "
          >
            Search
          </LoadingButton>
          <Button
            variant="contained"
            className="reset-button"
            onClick={handleReset}
          >
            Reset
          </Button>
        </Stack>
        {loading ? (
          <CircularProgress
            className="Loading"
            loading={"true"}
            size={100}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        ) : (
          <FeedbackTable pageNumber={values.page} />
        )}

        <Pagination
          sx={{
            marginLeft: "10px",
            marginRight: "10px",
            marginTop: "10px",
            paddingBottom: "10px",
            "Button.MuiPaginationItem-rounded.Mui-selected": {
              bgcolor: "rgb(35, 48, 68)",
              color: "rgb(238, 238, 238)",
            },
          }}
          page={values.page}
          count={parseInt(feedbackCount / 10) + (feedbackCount % 10 > 0 ? 1 : 0)}
          onChange={handlePageChange}
          shape="rounded"
          variant="outlined"
        />
      </Paper>
      <FeedbackView />
    </div>
  );
}
